var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1335 8.56673C15.1335 12.1934 12.1934 15.1335 8.56673 15.1335C4.94003 15.1335 2 12.1934 2 8.56673C2 4.94003 4.94003 2 8.56673 2C12.1934 2 15.1335 4.94003 15.1335 8.56673ZM15.4234 13.7032C16.4973 12.272 17.1335 10.4937 17.1335 8.56673C17.1335 3.83546 13.298 0 8.56673 0C3.83546 0 0 3.83546 0 8.56673C0 13.298 3.83546 17.1335 8.56673 17.1335C10.4937 17.1335 12.272 16.4973 13.7032 15.4234C13.7533 15.5046 13.8135 15.5813 13.8839 15.6516L17.773 19.5407C18.2611 20.0289 19.0526 20.0289 19.5407 19.5407C20.0289 19.0526 20.0289 18.2611 19.5407 17.773L15.6517 13.8839C15.5813 13.8135 15.5046 13.7533 15.4234 13.7032Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d1e4d985beb6edb07fb52518b4c473bf.svg";
export { ForwardRef as ReactComponent };